var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.$route.name !== 'manage')?_c('footer-final'):_vm._e(),_c('modal-cookies'),_c('div',{attrs:{"id":"ui"}},[_c('Tbar')],1),_c('popup-content'),_c('portal-target',{attrs:{"name":"modals"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }